import { AbstractControl, ValidatorFn } from '@angular/forms';
import { AsYouType, CountryCode, parsePhoneNumber } from 'libphonenumber-js';

export function getFormattedPhoneNumber(phoneNumber: string, locale: string): string {
  const localeCode = locale.split('-')[1].toUpperCase() as CountryCode;

  try {
    if (!isPhoneNumberValid(phoneNumber, locale)) {
      return phoneNumber;
    }
  } catch (error) {
    return phoneNumber;
  }

  const formatter = new AsYouType(localeCode);
  const formattedNumber = formatter.input(phoneNumber);

  return formattedNumber;
}

export function isPhoneNumberValid(phoneNumber: string, locale: string): boolean {
  const localeCode = locale.split('-')[1].toUpperCase() as CountryCode;

  let parsedNumber;

  try {
    parsedNumber = parsePhoneNumber(phoneNumber, localeCode);
  } catch (error) {
    return false;
  }

  return parsedNumber.isValid();
}

export function getPhoneNumberWithoutDialCode(phoneNumber: string, locale: string): string {
  const localeCode = locale.split('-')[1].toUpperCase() as CountryCode;

  const formatter = new AsYouType(localeCode);
  formatter.input(phoneNumber);

  const _phoneNumber = formatter.getNumber()?.nationalNumber;

  return _phoneNumber;
}

export namespace PhoneValidators {
  export function validatePhoneNumber(locale: string): ValidatorFn {
    const localeCode = locale.split('-')[1].toUpperCase() as CountryCode;
    const formatter = new AsYouType(localeCode);

    return (control: AbstractControl): { [key: string]: any } | null => {
      const inputValue: string = control.value;

      if (!inputValue) {
        return { phoneEmpty: true };
      }

      if (!Number.isInteger(+inputValue)) {
        return { phoneInvalidCharacters: true };
      }

      formatter.reset();
      formatter.input(inputValue);

      try {
        if (!formatter.isPossible()) {
          return { phoneInvalid: true };
        }
      } catch (error) {}

      return null;
    };
  }
}
